export default "__VITE_ASSET__dvtnxS0A__"